import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { AndresB_Video3 } from '../../../../../utils/ES/Modals/aiArtists';

const ModalVideoAndres3 = () => {
  return (
    <>
      <ModalVideo
        id="andres-video-3"
        dataText={AndresB_Video3}
        videoSrc="https://www.youtube.com/embed/rQW-_FeXPOU?si=6DWGRQuMcdLGjuus"
        videoTitle="KUTER_STUDIO_AI_ANDRES_VIDEO_3"
      />
    </>
  );
};

export default ModalVideoAndres3;
